import { _ as _defineProperty } from './dep-6108ca17.js';

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

var _excluded = ["attrs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var renderChildNode = function renderChildNode(createElement, node, childProps) {
  var processedAttrs = {};
  if (node.attrs) {
    for (var _i = 0, _Object$entries = Object.entries(node.attrs); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (typeof value === "string" && value.startsWith("props.")) {
        var propName = value.split(".")[1];
        processedAttrs[key] = childProps[propName];
      } else {
        processedAttrs[key] = value;
      }
    }
  }
  return createElement(node.tag, {
    attrs: _objectSpread(_objectSpread({}, node.attrs), processedAttrs)
  }, (node.children || []).map(function (child) {
    return renderChildNode(createElement, child, childProps);
  }));
};
var renderFn = function renderFn(createElement, node, rootData) {
  var _strokeColor$, _fillColor$;
  var iconAttrs = _objectSpread(_objectSpread({}, node.attrs), rootData.attrs);
  var attrs = rootData.attrs,
    restProps = _objectWithoutProperties(rootData, _excluded);
  var _ref = rootData.props || {},
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
    _ref$strokeColor = _ref.strokeColor,
    strokeColor = _ref$strokeColor === void 0 ? "currentColor" : _ref$strokeColor,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? "transparent" : _ref$fillColor;
  var filledColor;
  if (!rootData.props.fillColor) filledColor = "currentColor";else filledColor = Array.isArray(fillColor) ? fillColor[0] : fillColor;
  var childProps = {
    strokeWidth: strokeWidth,
    strokeColor1: Array.isArray(strokeColor) ? strokeColor[0] : strokeColor,
    strokeColor2: Array.isArray(strokeColor) ? (_strokeColor$ = strokeColor[1]) !== null && _strokeColor$ !== void 0 ? _strokeColor$ : strokeColor[0] : strokeColor,
    fillColor1: Array.isArray(fillColor) ? fillColor[0] : fillColor,
    fillColor2: Array.isArray(fillColor) ? (_fillColor$ = fillColor[1]) !== null && _fillColor$ !== void 0 ? _fillColor$ : strokeColor[0] : fillColor,
    filledColor: filledColor
  };
  return createElement(node.tag, _objectSpread({
    attrs: iconAttrs
  }, restProps), (node.children || []).map(function (child) {
    return renderChildNode(createElement, child, childProps);
  }));
};

export { _objectWithoutProperties as _, renderFn as r };
//# sourceMappingURL=dep-ceaccefb.js.map
